export const formatAED = (value) => {
  const amount = Number(value || 0);

  if (!Number.isFinite(amount)) {
    return "AED 0";
  }

  return `AED ${amount % 1 === 0 ? amount.toFixed(0) : amount.toFixed(2)}`;
};
